<div>
  <p-panel header="Gold Card">
    @if (goldCardMessage) {
      <p-message severity="info">
        <p class="font-semibold">{{ goldCardMessage.summary }}</p>
        <p>{{ goldCardMessage.detail }}</p>
      </p-message>
    }

    <div class="mt-4">
      <servicing-facility
        [servicingFacility]="authRequestState?.servicingFacility"
        [tenantName]="tenantName"
        [isInternal]="isInternal"
        [isGoldCardVisible]="isGoldCardVisible"
      ></servicing-facility>
    </div>
    <div class="mt-4">
      <ordering-provider
        [orderingProvider]="authRequestState?.orderingProvider"
        [isGoldCardVisible]="isGoldCardVisible"
      ></ordering-provider>
    </div>
  </p-panel>

  <div class="flex justify-between pt-6">
    <div>
      <button
        pButton
        severity="danger"
        aria-label="Cancel Create Authorization"
        label="Cancel"
        icon="pi pi-times"
        type="button"
        data-test-id="cancel-request-button"
        (click)="onCancel()"
      ></button>
    </div>

    <div>
      <button
        pButton
        aria-label="Back Step to Servicing Facility"
        label="Back"
        icon="pi pi-arrow-left"
        class="p-button-secondary mr-2"
        type="button"
        data-test-id="back-step-button"
        (click)="onClickBack()"
      ></button>
      <button
        pButton
        aria-label="Next Step to ClinicalInformation"
        label="Next"
        icon="pi pi-arrow-right"
        iconPos="right"
        type="button"
        data-test-id="next-step-button"
        (click)="onSubmit()"
      ></button>
    </div>
  </div>
</div>

